import styles from './BalanceUpdateNotification.module.scss';

import { Toast } from '@/components/Toast';
import { useStore } from '@/store';
import { formatNumber, formatTokenAmount } from '@/utils';

import Vote from '@/shared/icons/voteSmall.svg?react';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import ConfettiExplosion from 'react-confetti-explosion';
import { useTranslation } from 'react-i18next';

import Cup from './images/cup.png';

export const BalanceUpdateNotification = observer(() => {
  const { t } = useTranslation();
  const {
    notificationStore: {
      balanceChanges,
      setNotificationType,
      clearBalanceChanges,
    },
    walletStore: { basicAsset },
  } = useStore();

  const { usd, tokens } = balanceChanges;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setNotificationType(null);
      clearBalanceChanges();
    }, 3000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Toast>
      <div className={styles.wrapper}>
        <span className={styles.message}>{t('You have received')}</span>
        {tokens > 0 && (
          <>
            <Vote />
            <span className={styles.currency}>{formatNumber(tokens)}</span>
          </>
        )}
        {usd > 0 && (
          <>
            <basicAsset.smallIcon width={22} height={22} />
            <span className={styles.currency}>
              {formatTokenAmount(usd, basicAsset.decimals)}
            </span>
          </>
        )}
        <img src={Cup} alt="cup" className={styles.cup} />
        <ConfettiExplosion
          className={styles.confetti}
          force={0.8}
          duration={3000}
          particleCount={300}
          width={1000}
          zIndex={100}
        />
      </div>
    </Toast>
  );
});
